import { render, staticRenderFns } from "./DependentForm.vue?vue&type=template&id=08849b55&"
import script from "./DependentForm.vue?vue&type=script&lang=js&"
export * from "./DependentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports